import { Dialog, Flex } from '@shared/components';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { PreviewQuestionContent, QuestionPreviewModalHeader } from '../../components';

interface PreviewSingleQuestionModalProps {
  open: boolean;
  onClose: () => void;
}

export default function PreviewSingleQuestionModal(
  props: Readonly<PreviewSingleQuestionModalProps>,
) {
  const { open, onClose } = props;

  const formContext = useFormContext();
  const { watch } = formContext;

  const details = formContext.watch('detail.details');
  const choices = useMemo(() => {
    const choices = watch('detail.choices') ?? [];
    const correctAnswer = watch('detail.correctAnswer.value');

    return choices.map((choice: { value: string; label: string; order: number }) => ({
      label: choice.label,
      order: choice.order,
      isCorrect: choice.value === correctAnswer,
    }));
  }, [formContext]);

  return (
    <Dialog fullScreen open={open} onClose={onClose}>
      <QuestionPreviewModalHeader onBack={onClose} />
      <Flex
        sx={(theme) => ({
          bgcolor: theme.palette.grey[50],
          p: theme.spacing(6),
          width: '100%',
          minHeight: 'max-content',
          height: 'calc(100% - 68px)',
        })}
      >
        <Flex
          sx={(theme) => ({
            p: theme.spacing(6),
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(6),
            borderRadius: theme.shape.rounded(4),
            boxShadow: theme.shadows[2],
            width: '100%',
            minHeight: '100%',
          })}
        >
          <PreviewQuestionContent details={details} choices={choices} />
        </Flex>
      </Flex>
    </Dialog>
  );
}
